module.exports = __webpack_public_path__ + "img/logobpbverde.a6b1c019.png";